import React, { useState } from 'react';
import Layout from '../components/Layout/Layout';
import { toast, Toaster } from 'react-hot-toast'; // Import toast and Toaster
import axios from 'axios'; // Import axios
import "../styles/register.css";
import { useNavigate } from 'react-router-dom';

const Register = () => {


    const [imageFile, setImageFile] = useState<File | null>(null);
    const [imageUrl, setImageUrl] = useState<string | null>(null);

  const navigate = useNavigate();

    // Handle image input
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files ? e.target.files[0] : null;
      console.log(file)
      if (file) {
        console.log(file)
        setImageFile(file);
        setImageUrl(URL.createObjectURL(file));
        
      }
    };


  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    password: '',
    confirmPassword: '',
    category: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCategoryChange = (e) => {
    setFormData({
      ...formData,
      category: e.target.value,
    });
  };


  




  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
  data.append('fullName', formData.fullName);
  data.append('email', formData.email);
  data.append('phoneNumber', formData.phoneNumber);
  data.append('password', formData.password);
  data.append('confirmPassword', formData.confirmPassword);
  data.append('category', formData.category);

  if (imageFile) {
    data.append('image', imageFile); // 👈 very important: the key must match your multer config (e.g. `upload.single('image')`)
  }

    // Validate if passwords match before submitting
    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!"); // Show error toast if passwords don't match
      return;
    }



    try {
      const response = await fetch(
        `${process.env.REACT_APP_MODE === 'development' ? "http://localhost:8000/api/v1" : `${process.env.REACT_APP_API_URL}`}/auth/register`, {
        method: 'POST',
        body: data // Send the form data as a JSON object
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("OTP sending...");
        sendOTP(e);

      } else {
        toast.error(result.message || 'Registration failed!'); // Show error toast if registration fails
      }
    } catch (error) {
      console.error('Error during registration:', error);
      toast.error('An error occurred. Please try again.'); // Show general error toast
    }
  };



  const sendOTP = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_MODE === 'development' ? "http://localhost:8000/api/v1" : `${process.env.REACT_APP_API_URL}`}/auth/send-otp`, {
        email: formData.email
      });
      if (res && res.data.success) {
        toast.success(res.data.message);
        // this.props.history.push({
        //   pathname: '/otp-verification',
        //     state: email
        // })
        toast.success("Check your email for OTP");
        navigate('/verify',{state:{email:formData.email}});
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      // console.log(error);
      toast.error(error.response.data.message);
    }
  };

  



  return (
    <Layout title={"Lastbites: Register"} children={undefined} description={undefined} keywords={undefined} author={undefined}>
      <main className="register">
        <div className="container">
          <div className="title">Registration</div>
          <div className="content1">
            <form onSubmit={handleSubmit}>
              <div className="user-details">
                {/* Input for Full Name */}
                <div className="input-box">
                  <span className="details">Full Name</span>
                  <input
                    type="text"
                    placeholder="Enter your name"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                {/* Input for Email */}
                <div className="input-box">
                  <span className="details">Email</span>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                {/* Input for Phone Number */}
                <div className="input-box">
                  <span className="details">Phone Number</span>
                  <input
                    type="text"
                    placeholder="Enter your number"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                {/* Input for Password */}
                <div className="input-box">
                  <span className="details">Password</span>
                  <input
                    type="password"
                    placeholder="Enter your password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                {/* Input for Confirm Password */}
                <div className="input-box">
                  <span className="details">Confirm Password</span>
                  <input
                    type="password"
                    placeholder="Confirm your password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="category-details">
                <span className="event-title">Category</span>
                <div className="category">
                  {/* Radio buttons for category selection */}
                  <label htmlFor="dot-1" style={{ marginRight: '15px' }}>
                    <input
                      type="radio"
                      name="category"
                      value="NGO"
                      id="dot-1"
                      checked={formData.category === 'NGO'}
                      onChange={handleCategoryChange}
                      style={{ marginRight: '5px' }}
                    />
                    NGO
                  </label>
                  <label htmlFor="dot-2" style={{ marginRight: '15px' }}>
                    <input
                      type="radio"
                      name="category"
                      value="RESTAURANT"
                      id="dot-2"
                      checked={formData.category === 'RESTAURANT'}
                      onChange={handleCategoryChange}
                      style={{ marginRight: '5px' }}
                    />
                    RESTAURANT
                  </label>
                  <label htmlFor="dot-3" style={{ marginRight: '15px' }}>
                    <input
                      type="radio"
                      name="category"
                      value="EVENT"
                      id="dot-3"
                      checked={formData.category === 'EVENT'}
                      onChange={handleCategoryChange}
                      style={{ marginRight: '5px' }}
                    />
                    EVENT
                  </label>
                  <label htmlFor="dot-4" style={{ marginRight: '15px' }}>
                    <input
                      type="radio"
                      name="category"
                      value="HOSTEL"
                      id="dot-4"
                      checked={formData.category === 'HOSTEL'}
                      onChange={handleCategoryChange}
                      style={{ marginRight: '5px' }}
                    />
                    HOSTEL
                  </label>
                  <label htmlFor="dot-5" style={{ marginRight: '15px' }}>
                    <input
                      type="radio"
                      name="category"
                      value="OTHER"
                      id="dot-5"
                      checked={formData.category === 'OTHER'}
                      onChange={handleCategoryChange}
                      style={{ marginRight: '5px' }}
                    />
                    OTHER
                  </label>
                </div>
              </div>

                {/* Image Upload */}
              <div className="image-upload">
                <h2>Upload Photo ID (For Identity verification)</h2>
                <input 
                  type="file" 
                  accept="image/*,application/pdf"
                  name="image"
                  onChange={handleFileChange} 
                  required
                />
                {/* {imageUrl && (
                  <div>
                    <h3>Preview:</h3>
                    <img src={imageUrl} alt="Preview" style={{ width: '100px', height: '50px' }} />
                  </div>
                )}
                {imageFile && <p>Uploaded file: {imageFile.name}</p>} */}
              </div>

              {/* Submit button */}
              <div className="button">
                <input type="submit" value="Register" />
              </div>
            </form>
          </div>
        </div>
      </main>

      {/* Toast Container */}
      <Toaster position="top-center" reverseOrder={false} />
    </Layout>
  );
};

export default Register;



